import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79edbd7b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "repeat-order-cart-modal" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "mt-2" }
const _hoisted_5 = { class: "asahi-radio-button-container pb-2" }
const _hoisted_6 = ["name", "value", "checked"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1))
const _hoisted_8 = { class: "label-container" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "asahi-radio-button-container pb-2" }
const _hoisted_11 = ["name", "value", "checked"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1))
const _hoisted_13 = { class: "label-container" }
const _hoisted_14 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AsahiTypography = _resolveComponent("AsahiTypography")!
  const _component_AsahiButton = _resolveComponent("AsahiButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_AsahiTypography, {
      type: "body-2-bold",
      class: "d-block mb-3"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('Seems like you have an order in progress').toUpperCase()), 1)
      ]),
      _: 1
    }),
    _createElementVNode("span", {
      class: "d-block",
      innerHTML:  _ctx.continueModalTitle ? _ctx.continueModalTitle : _ctx.$t('Do you want to proceed with the current order or start a new one?')
    }, null, 8, _hoisted_2),
    _createElementVNode("span", {
      class: "d-block",
      innerHTML:  _ctx.continueModalSubTitle ? _ctx.continueModalSubTitle : _ctx.$t('Please choose from the options below:')
    }, null, 8, _hoisted_3),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: _normalizeClass([ _ctx.isSelected(_ctx.continueValue) ? 'option-container-checked' : 'option-container', 'p-3', 'my-3']),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.select(_ctx.continueValue)))
      }, [
        _createElementVNode("label", _hoisted_5, [
          _createElementVNode("div", null, [
            _createElementVNode("input", {
              name: _ctx.name,
              type: "radio",
              value: _ctx.continueValue,
              checked: _ctx.isSelected(_ctx.continueValue)
            }, null, 8, _hoisted_6),
            _hoisted_7
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", {
              class: "option-description mt-1",
              innerHTML: _ctx.continueModalContinueMessage ? _ctx.continueModalContinueMessage :_ctx.$t('Continue with the current order and maintain available products in my cart.')
            }, null, 8, _hoisted_9)
          ])
        ])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass([ _ctx.isSelected(_ctx.newValue) ? 'option-container-checked' : 'option-container', 'p-3', 'my-3']),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.select(_ctx.newValue)))
      }, [
        _createElementVNode("label", _hoisted_10, [
          _createElementVNode("div", null, [
            _createElementVNode("input", {
              name: _ctx.name,
              type: "radio",
              value: _ctx.newValue,
              checked: _ctx.isSelected(_ctx.newValue)
            }, null, 8, _hoisted_11),
            _hoisted_12
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", {
              class: "option-description mt-1",
              innerHTML: _ctx.continueModalNewMessage ? _ctx.continueModalNewMessage : _ctx.$t('Start a new Order.')
            }, null, 8, _hoisted_14)
          ])
        ])
      ], 2)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["d-flex mt-2", _ctx.isMobile ? 'w-100 justify-content-center': 'justify-content-end'])
    }, [
      _createVNode(_component_AsahiButton, {
        type: "primary",
        onClick: _cache[2] || (_cache[2] = () => _ctx.proceed()),
        class: _normalizeClass([{'w-100': _ctx.isMobile}, "w-150"])
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('Proceed')), 1)
        ]),
        _: 1
      }, 8, ["class"])
    ], 2)
  ]))
}